import { render, staticRenderFns } from "./muokkaa-arviointia.vue?vue&type=template&id=16c3db07&scoped=true&"
import script from "./muokkaa-arviointia.vue?vue&type=script&lang=ts&"
export * from "./muokkaa-arviointia.vue?vue&type=script&lang=ts&"
import style0 from "./muokkaa-arviointia.vue?vue&type=style&index=0&id=16c3db07&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c3db07",
  null
  
)

export default component.exports